<div class="wrapper">
  <app-dashboard>
    <div class="page">
      <div class="card-holder">
        <div class="card">
          <div>
            <p class="header">Total Configuration</p>
            <p class="data">{{ this.total }}</p>
          </div>
          <div class="icon-container">
            <img src="../../../assets/icons/total.svg" alt="" />
          </div>
        </div>
        <div class="card">
          <div>
            <p class="header">Total Incoming</p>
            <p class="data">{{ this.receiving }}</p>
          </div>
          <div class="icon-container">
            <img src="../../../assets/icons/incoming.svg" alt="" />
          </div>
        </div>
        <div class="card">
          <div>
            <p class="header">Total Outgoing</p>
            <p class="data">{{ this.sending }}</p>
          </div>
          <div class="icon-container">
            <img src="../../../assets/icons/outgoing.svg" alt="" />
          </div>
        </div>
      </div>
      <div class="recent-requests">
        <h1>Recent Requests</h1>
        <app-request-table [data]="requests" [view]="singleRequest" [processLoading]="fetchingData"></app-request-table>
        <!-- <app-filter [data]="this.data" (filterChanged)="onFilterChanged($event)"></app-filter> -->

        <!-- <app-table
          [action]="singleRequest"
          [fetchingData]="fetchingData"
          [headers]="tableHeaders"
          [data]="tableData"
          [canResend]="true"
        ></app-table> -->
      </div>
    </div>
  </app-dashboard>
</div>

<app-modal
  [title]="this.webhookConfig.name"
  [dateCreated]="this.webhookConfig.createdAt"
  [dateUpdated]="this.webhookConfig.updatedAt"
  [isOpen]="isModalOpen"
  (closeModalEvent)="closeModal()"
>
  <!-- <span>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Enim eaque nisi excepturi dolores alias sapiente exercitationem provident, asperiores quia cupiditate soluta ratione facere ipsam sint accusantium, modi ut esse. Illum, vero fugiat ducimus voluptates animi fuga ea aliquam fugit facilis exercitationem est sunt corporis commodi natus mollitia nisi, nemo, quisquam accusamus. Obcaecati, illo facere molestiae repellendus consectetur voluptatum sunt animi rem consequatur error aperiam ad quasi fugiat odit doloremque, itaque ratione praesentium, dolorem aliquam ut debitis. Est placeat pariatur rerum, assumenda totam unde, alias, reiciendis possimus repudiandae quibusdam doloribus velit iusto? Aperiam deserunt nisi ab consequatur, veritatis autem excepturi ratione repellendus mollitia at modi sequi. Necessitatibus officia, ullam incidunt soluta provident facere, deleniti laudantium dolorem similique beatae iusto asperiores. Dolores maiores exercitationem laboriosam fugiat sit animi voluptatum tenetur aliquid, perspiciatis recusandae mollitia architecto autem repudiandae. Cupiditate veniam voluptatem ipsam eligendi, exercitationem repellendus tenetur quos quia, ducimus consectetur nisi voluptatum laborum, dolore quaerat recusandae consequatur! Sequi natus, laudantium architecto amet cupiditate aperiam maxime sit quis adipisci recusandae? Ex, illum? Autem cum modi possimus aliquid accusantium aliquam dignissimos doloremque fugiat accusamus nam, rerum ex commodi quo aut alias facilis magni fuga architecto nemo. Tempora perspiciatis natus quam consectetur assumenda quia tempore ea?</span> -->
  <div class="table-grid">
    <span class="key">Webhook ID</span>
    <span class="value">{{ this.individualRequest._id }}</span>

    <!-- <span class="key">Name</span>
    <span class="value">{{ this.webhookConfig.name }}</span> -->

    <!-- <span class="key">Created At</span>
    <span class="value">{{ this.webhookConfig.createdAt }}</span> -->

    <span class="key">Method</span>
    <span class="value">{{ this.individualRequest.method }}</span>

    <span class="key">URL</span>
    <span class="value">{{ this.individualRequest.url }}</span>

    <span class="key"> Status</span>
    <span class="value">{{ this.individualRequest.status }}</span>

    <span class="key">Response Status</span>
    <span class="value">{{ this.individualRequest.responseStatus }}</span>

    <span class="key">Trials</span>
    <span class="value">{{ this.individualRequest.trials }}</span>

    <span class="key">Required Trials</span>
    <span class="value">{{ this.individualRequest.requiredTrials }}</span>

    <span class="key">Request Body</span>
    <div class="value box" *ngIf="individualRequest?.body">
      <ngx-json-viewer [json]="individualRequest?.body"></ngx-json-viewer>
    </div>

    <span class="key">Response Body</span>
    <div
      class="value box"
      *ngIf="
        individualRequest?.response && individualRequest.response.length > 0">
      <ngx-json-viewer [json]="individualRequest?.response"></ngx-json-viewer>
    </div>
  </div>

  <!-- <div class="detail-section"> -->
  <!-- <div class="sub-detail">
        <h1>Webhook ID</h1>
        <p>{{this.individualRequest._id}}</p>
       </div>
       <div class="sub-detail">
        <h1>Name</h1>
        <p>{{this.webhookConfig.name}}</p>
       </div>
       <div class="sub-detail">
        <h1>Created At</h1>
        <p>{{this.webhookConfig.createdAt}}</p>
       </div>
       <div class="sub-detail">
        <h1>Method</h1>
        <p>{{this.individualRequest.method}}</p>
       </div>
       <div class="sub-detail">
        <h1>URL</h1>
        <p>{{this.individualRequest.url}}</p>
       </div>
       <div class="sub-detail">
        <h1>Response Status</h1>
        <p>{{this.individualRequest.responseStatus}}</p>
       </div>
       <div class="sub-detail">
        <h1>Trials</h1>
        <p>{{this.individualRequest.trials}}</p>
       </div>
       <div class="sub-detail">
        <h1>Required Trials</h1>
        <p>{{this.individualRequest.requiredTrials}}</p>
       </div>
       <div class="sub-detail">
        <h1>Response</h1>
        <div *ngIf="individualRequest.response && individualRequest.response.length > 0" [innerHTML]="individualRequest.response[0].body"></div>
       </div> -->

  <!-- </div> -->

  <!-- <div class="button"><app-button-outline [action]="closeModal" buttonText="Close"></app-button-outline></div> -->
</app-modal>
